<template>
  <v-dialog
    v-model="dialog"
    max-width="900px"
    persistent
  >
    <v-card>
      <v-card-title class="headline" style="background-color: #f5f5f5; border-bottom: 1px solid #e0e0e0;">
        <v-icon left color="teal">mdi-file-document-outline</v-icon>
        Documento de Proveedor
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="12">
            <iframe
              v-if="pdfUrl"
              :src="pdfUrl"
              style="width: 100%; height: 70vh; border: none;"
            ></iframe>
            <div v-else class="text-center pa-5">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <p class="mt-2">Cargando documento...</p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="amber darken-1"
          dark
          @click="downloadPdf"
          rounded
          elevation="3"
        >
          <v-icon left>mdi-download</v-icon>
          Descargar
        </v-btn>
        <v-btn
          color="light-blue darken-1"
          dark
          @click="close"
          rounded
          elevation="3"
          class="ml-2"
        >
          <v-icon left>mdi-close-circle</v-icon>
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    pdfUrl: {
      type: String,
      default: null
    },
    fileName: {
      type: String,
      default: 'documento.pdf'
    }
  },
  methods: {
    close() {
      this.$emit('update:dialog', false);
    },
    downloadPdf() {
      if (this.pdfUrl) {
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = this.pdfUrl;
        a.download = this.fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(this.pdfUrl);
        document.body.removeChild(a);
      }
    }
  }
}
</script>
